import React from 'react';
import { Checkbox } from 'tea-component';
import { List as VirtualizedList, AutoSizer } from 'react-virtualized';
import classnames from 'classnames';
import { IOptionsBoxProps } from '../../type';
import './index.scss';

const OptionBox = (props: IOptionsBoxProps) => {
  const {
    virtual,
    listHeight: propsHeight,
    options,
    rowHeight = 36,
    maxVisibleRows = 20,
    isMaxBox,
    onChange,
    optionRender,
  } = props || {};

  const getCheckboxNode = (item: any, style?: React.CSSProperties) => {
    const { value, disabled = false, checked, icon, render, text } = item || {};
    return (
      <div className="dbh-transfer-modal-options-list-row" style={style}>
        <Checkbox
          key={value}
          value={checked}
          name={value}
          disabled={isMaxBox ? !checked : disabled}
          style={{ width: '100%' }}
          onChange={(check) => {
            onChange?.(check, item);
          }}
        >
          {icon && <img src={icon} />}
          {render?.(item) || (
            <span
              dangerouslySetInnerHTML={{
                __html: `${text}`,
              }}
            />
          )}
        </Checkbox>
      </div>
    );
  };

  return (
    <div
      className={classnames('dbh-transfer-modal-options-list', {
        'dbh-virtual': virtual,
      })}
      style={propsHeight ? { height: propsHeight, maxHeight: propsHeight } : {}}
    >
      {virtual ? (
        <div
          style={virtual ? { height: `${options?.length * rowHeight}px` } : {}}
        >
          <AutoSizer>
            {({ width, height }: any) => {
              // 根据可用高度计算可见行数
              const visibleRowCount = Math.min(
                Math.floor(height / rowHeight),
                maxVisibleRows,
              );
              // 根据可见行数计算 VirtualizedList 的高度
              const listHeight = propsHeight || visibleRowCount * rowHeight;
              return (
                <VirtualizedList
                  rowCount={options?.length}
                  rowRenderer={({ index, style }: any) => {
                    const item = options?.[index];
                    if (typeof optionRender === 'function') {
                      return optionRender(item, style);
                    }
                    return getCheckboxNode(item, style);
                  }}
                  width={width}
                  height={listHeight}
                  rowHeight={rowHeight}
                  overscanRowCount={maxVisibleRows}
                />
              );
            }}
          </AutoSizer>
        </div>
      ) : (
        options?.map((item: any) => {
          if (typeof optionRender === 'function') {
            return optionRender(item);
          }
          return getCheckboxNode(item);
        })
      )}
    </div>
  );
};

export default OptionBox;
